import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ApiError } from '../api/ApiError';

/**
 * Egységes hibamegjelenítés a backend problem+json válaszaiból.
 *
 * A szövegeket NEM itt találjuk ki: a szerver `title`/`detail` mezője már
 * magyar és a következő lépést is megmondja. A `correlationId` azért
 * látszik, mert egy hibabejelentésnél ez az egyetlen fogódzó, amivel a
 * kérés visszakereshető a szerveroldali naplóban.
 */
export function ProblemAlert({ error }: { error: unknown }) {
  if (!error) return null;

  if (!(error instanceof ApiError)) {
    return (
      <Alert severity="error">
        <AlertTitle>Váratlan hiba</AlertTitle>
        {error instanceof Error ? error.message : String(error)}
      </Alert>
    );
  }

  const fieldErrors = error.fieldErrors;

  return (
    <Alert severity={error.status >= 500 || error.status === 0 ? 'error' : 'warning'}>
      <AlertTitle>{error.titleHu}</AlertTitle>
      {error.detail && <Typography variant="body2">{error.detail}</Typography>}

      {fieldErrors.length > 0 && (
        <Box component="ul" sx={{ mt: 1, mb: 0, pl: 3 }}>
          {fieldErrors.map((fe) => (
            <li key={`${fe.mezo}-${fe.uzenet}`}>
              <Typography variant="body2">
                <strong>{fe.mezo}</strong>: {fe.uzenet}
              </Typography>
            </li>
          ))}
        </Box>
      )}

      {error.correlationId && (
        <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.75 }}>
          Hibaazonosító: {error.correlationId}
        </Typography>
      )}
    </Alert>
  );
}
